import { TimelineGroupController } from '../controller/TimelineGroupController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { Alerts } from '../types';

export class TimelineGroupWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TimelineGroupController,
    });
  }

  get alertsData(): Alerts {
    const value = this.getAttribute('data-alerts-data');
    return value ? JSON.parse(value) : [];
  }

  set alertsData(value: Alerts) {
    if (!value) {
      return;
    }
    this.setAttribute('data-alerts-data', JSON.stringify(value));
  }
}
